import { boolean } from "zod";

// display badge based on product type & price range
const getProductPriceHtml = ({
    type = "simple",
    price = "0",
    regularPrice = "0",
    salePrice = "0",
    variationPricesMin = "0",
    variationPricesMax = "0",
    userDiscountPercentage = 0,
    onSale = false,
    productDiscountable = false,
}: {
    type: "simple" | "variable";
    price: string;
    regularPrice: string;
    salePrice: string;
    variationPricesMin: string | undefined;
    variationPricesMax: string | undefined;
    userDiscountPercentage: number;
    onSale: boolean;
    productDiscountable?: boolean;
}) => {
    const userDiscount = (100 - userDiscountPercentage) / 100;
    let outputHtml = "";
    if (type === "simple") {
        if (onSale === true) {
            outputHtml = `<del aria-hidden="true"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                regularPrice
            ).toFixed(
                2
            )}</bdi></span></del> <ins><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                salePrice
            ).toFixed(2)}</bdi></span></ins>`;
        } else {
            if (productDiscountable && userDiscountPercentage > 0) {
                // round to the nearest number
                const discountedPrice = (Number(price) * userDiscount).toFixed(
                    2
                );
                outputHtml = `<del aria-hidden="true"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                    price
                ).toFixed(
                    2
                )}</bdi></span></del> <ins><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${discountedPrice}</bdi></span></ins>`;
            } else {
                outputHtml = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                    price
                ).toFixed(2)}</bdi></span>`;
            }
        }
    } else if (type === "variable") {
        if (onSale === true) {
            outputHtml = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                variationPricesMin
            ).toFixed(
                2
            )}</bdi></span> – <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                variationPricesMax
            ).toFixed(2)}</bdi></span>`;
        } else {
            if (variationPricesMin === variationPricesMax) {
                if (productDiscountable && userDiscountPercentage > 0) {
                    // round to the nearest number
                    const discountedPriceMin = (
                        Number(variationPricesMin) * userDiscount
                    ).toFixed(2);
                    outputHtml = `<del aria-hidden="true"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                        variationPricesMin
                    ).toFixed(
                        2
                    )}</bdi></span></del> <ins><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${discountedPriceMin}</bdi></span></ins>`;
                } else {
                    outputHtml = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                        variationPricesMin
                    ).toFixed(2)}</bdi></span>`;
                }
            } else {
                if (productDiscountable && userDiscountPercentage > 0) {
                    // round to the nearest number
                    const discountedPriceMin = (
                        Number(variationPricesMin) * userDiscount
                    ).toFixed(2);
                    const discountedPriceMax = (
                        Number(variationPricesMax) * userDiscount
                    ).toFixed(2);
                    outputHtml = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${discountedPriceMin}</bdi></span> – <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${discountedPriceMax}</bdi></span>`;
                } else {
                    outputHtml = `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                        variationPricesMin
                    ).toFixed(
                        2
                    )}</bdi></span> – <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>${Number(
                        variationPricesMax
                    ).toFixed(2)}</bdi></span>`;
                }
            }
        }
    }
    return outputHtml;
};
export default getProductPriceHtml;
